/**
 * User Journey Guide API Service
 * Handles API calls for user journey guide settings (backend storage).
 * Uses POST /discovery/user_journey_guide_settings (same structure as other discovery APIs).
 */
import httpClient from '../httpClient';

const DISCOVERY_USER_JOURNEY_SETTINGS = '/discovery/user_journey_guide_settings';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('ids_token')}`,
  'Content-Type': 'application/json'
});

/**
 * Get user journey guide settings from backend
 * @returns {Promise<Object>} { status, data: { key: value } }
 */
export const getUserJourneyGuideSettings = async () => {
  const response = await httpClient.post(DISCOVERY_USER_JOURNEY_SETTINGS, {}, {
    headers: authHeaders()
  });
  return response.data;
};

/**
 * Update user journey guide settings
 * @param {Object} settings - { key: value } pairs to set
 * @returns {Promise<Object>} API response
 */
export const updateUserJourneyGuideSettings = async (settings) => {
  const response = await httpClient.post(DISCOVERY_USER_JOURNEY_SETTINGS, { settings }, {
    headers: authHeaders()
  });
  return response.data;
};

/**
 * Reset all user journey guide settings (Start User Journey)
 * @returns {Promise<Object>} API response
 */
export const resetUserJourneyGuideSettings = async () => {
  const response = await httpClient.post(DISCOVERY_USER_JOURNEY_SETTINGS, { action: 'reset' }, {
    headers: authHeaders()
  });
  return response.data;
};
